import fileDownload from 'js-file-download';
import type {FileResponse} from 'src/api/ProactApiClient';
import {useAlert} from 'src/shared/hooks/useAlert';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';
import {getBrowserTimeZone} from 'src/shared/utils/timeZone';

export type DocumentProducer = (
  timeZone: string
) => Promise<FileResponse | null | undefined>;

/**
 * Unwrap-download-alert flow for server-generated documents. The producer
 * receives the browser time zone; the backend's filename wins over the fallback.
 */
export function useDocumentDownload() {
  const {setAlert} = useAlert();

  const download = async (
    produce: DocumentProducer,
    fallbackFileName: string
  ): Promise<boolean> => {
    try {
      const res = await produce(getBrowserTimeZone());
      if (!res) {
        setAlert('Failed to generate the document.', 'error');
        return false;
      }
      fileDownload(res.data, res.fileName ?? fallbackFileName);
      return true;
    } catch (error) {
      setAlert(parseErrorMessage(error), 'error');
      return false;
    }
  };

  return {download};
}
